// import { EMP_ATTENDANCE } from "../action_types";
const initialstate = {
    permissions: [],
  };
  export const Permission = (state = initialstate, { type, payload }) => {
    switch (type) {
      case "SET_CHECKED": {
        return {
         ...state,
           permissions: [...state.permissions,payload]
        };
      } 
      case "SET_UNCHECKED": {
        return {
          ...state,
           permissions: state.permissions.filter((item) => item !== payload)
        };
      }  
      case "SET_USER_PERMISSION": {
        return {
          ...state,
          permissions: payload
        };
      } 
      case "SET_NULL": {
        return {
          ...state,
          permissions: []
        };
      } 
      
     
      
      default: {
        return { ...state };
      }
    }
  };
  